module.exports = __webpack_public_path__ + "img/500.2b6dfbad.svg";